export default __webpack_public_path__ + "static/media/img_sqlserver-colorBkg.35f6d040.png";